// extracted by mini-css-extract-plugin
export default {"DataSources":"light__DataSources___JDVEI","dataSourcesRow":"light__dataSourcesRow___UKLjQ","switchRow":"light__switchRow___jjV9i","dataSourceSave":"light__dataSourceSave___LCiaJ"};